<template>
  <div class="exam">
    <template v-if="countDown.CountDown || countDown.CountDown === 0">
      <h4>距<span>{{mainConfig.ClassCName}}</span>考试</h4>
      <div class="unconfirmed" v-if="countDown.CountDown === 0">【暂未确定】</div>
      <div class="time" v-else>
        <div class="num">
          <span>{{Math.floor(countDown.CountDown / 100)}}</span>
          <span>{{Math.floor(countDown.CountDown / 10) % 10}}</span>
          <span>{{countDown.CountDown % 10}}</span>
        </div>
        <div class="unit">天</div>
      </div>
    </template>
    <div class="links">
      <template v-if="unionBkzn.open === 1">
        <a target="_blank" v-for="(item, index) in unionBkzn.data" :key="item.id" :href="'/bkzn/pc/#/?id=' + item.id">
          <img src="https://img2.233.com/wx/union/pure/pc/cl_ic_1.png" v-if="index === 0">
          <img src="https://img2.233.com/wx/union/pure/pc/cl_ic_2.png" v-if="index === 1">
          <img src="https://img2.233.com/wx/union/pure/pc/cl_ic_3.png" v-if="index === 2">
          <img src="https://img2.233.com/wx/union/pure/pc/cl_ic_4.png" v-if="index === 3">
          <img src="https://img2.233.com/wx/union/pure/pc/cl_ic_5.png" v-if="index === 4">
          <img src="https://img2.233.com/wx/union/pure/pc/cl_ic_6.png" v-if="index === 5">
          <p>{{item.title}}</p>
        </a>
      </template>
      <template v-else>
        <router-link target="_blank" tag="a" v-for="(item, index) in mainConfig.CategoryOtherClassList" :key="item.ClassEName" :to="{ path: '/', query: { class: item.ClassEName }}">
          <img src="https://img2.233.com/wx/union/pure/pc/cl_ic_1.png" v-if="index === 0">
          <img src="https://img2.233.com/wx/union/pure/pc/cl_ic_2.png" v-if="index === 1">
          <img src="https://img2.233.com/wx/union/pure/pc/cl_ic_3.png" v-if="index === 2">
          <img src="https://img2.233.com/wx/union/pure/pc/cl_ic_4.png" v-if="index === 3">
          <img src="https://img2.233.com/wx/union/pure/pc/cl_ic_5.png" v-if="index === 4">
          <img src="https://img2.233.com/wx/union/pure/pc/cl_ic_6.png" v-if="index === 5">
          <p>{{item.ClassCName}}</p>
        </router-link>
      </template>
    </div>
    <div class="adv">
      <a :href="mainConfig.ActivityUrl" target="_blank" v-if="mainConfig.ActivityUrl">
        <img :src="mainConfig.ActivityImgs">
      </a>
      <a v-else>
        <img :src="mainConfig.ActivityImgs">
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Exam",
  props: {
    mainConfig: {
      type: Object,
      default: () => {}
    },
    unionBkzn: {
      type: Object,
      default: () => {}
    },
    countDown: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../assets/css/index.scss";
.exam{
  width: 274px;
  height: 100%;
  background: #fff;
  box-shadow: 1px 15px 18px 1px rgba(0, 0, 0, 0.02);
  padding: 0 14px;
  text-align: center;
  box-sizing: border-box;
  h4{
    font-weight: 400;
    color: #343434;
    font-size: 16px;
    line-height: 60px;
    span{
      font-weight: bold;
    }
  }
  .time{
    display: flex;
    align-items: center;
    justify-content: center;
    .num{
      position: relative;
      &::after{
        content: "";
        position: absolute;
        height: 2px;
        width: 100%;
        top: calc(50% - 1px);
        left: 0;
        background: #fff;
      }
      span{
        display: inline-block;
        width: 34px;
        height: 47px;
        line-height: 47px;
        background: #DF3030;
        @include recommend_exam_background();
        font-size: 42px;
        font-weight: bold;
        color: #fff;
        margin-right: 4px;
      }
    }
    .unit{
      font-size: 15px;
      color: #565656;
      font-weight: 400;
      margin: 16px 0 0 4px;
    }
  }
  .unconfirmed{
    line-height: 47px;
    font-size: 18px;
    font-weight: 400;
    color: #9A9A9A;
  }
  .links{
    margin: 16px 0;
    display: flex;
    flex-wrap: wrap;
    background: #FDFDFD;
    border: 1px dashed #D8DDE1;
    a{
      width: 33.33%;
      height: 90px;
      padding: 15px 0;
      border-right: 1px solid #F2F3F4;
      border-bottom: 1px solid #F2F3F4;
      box-sizing: border-box;
      text-decoration: none;
      &:hover p{
        @include globe_hover_color();
      }
      &:nth-child(3n){
        border-right: none;
      }
      &:nth-child(n + 4){
        border-bottom: none;
      }
      img{
        width: 29px;
        height: 29px;
      }
      p{
        color: #565656;
        font-size: 14px;
        font-weight: bold;
        margin-top: 7px;
        line-height: 20px;
        width: 100%;
        overflow: hidden;
        height: 20px;
      }
    }
  }
  .adv{
    img{
      width: 100%;
      height: 65px;
    }
  }
}
</style>